module.exports = __webpack_public_path__ + "img/img-box-5.6f94a31e.png";